export default "__VITE_ASSET__CfiI$t_0__"